<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Orona">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Orona"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Dr. Ignacio Orona Castillo</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> orokaz@yahoo.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="red">mdi-alpha-x-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> s/n
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO</b>
                        <br>
                        <br>
                        <p>“Optimización de los Recursos Agua y Suelo".</p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            ING. AGRONOMO EN ECONOMIA AGRICOLA (1981)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIV. AUT. AGRARIA ANTONIO NARRO, BUENAVISTA, SALTILLO, COAH.
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>PLANEACION AGROPECUARIA (1986)</li>
                            <p>
                                UNIV. AUT. AGRARIA ANTONIO NARRO, BUENAVISTA, SALTILLO, COAH.
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>ECONOMIA (1999)</li>
                            <p>
                                COLEGIO DE POSGRADUADOS, MONTECILLO, EDO. MEX.
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>ECONOMIA AGRICOLA Y DE LOS RECURSOS NATURALES</li>
                        </ul>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>MÁS INFORMACIÓN.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon" class="pb-1">
                        <v-btn color="blue" @click="info = false; mostrarPublicaciones = true" text>Publicaciones</v-btn>
                        <br>
                        <v-btn color="blue" @click="info = false; mostrarProyectos = true" text>Proyectos</v-btn>
                    </div>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarPublicaciones == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PUBLICACIONES.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarPublicaciones = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headers" :items="Tabla" group-by="categoria"  item-key="numero"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
            <div class="divEstudiosInfo" v-if="info == false && mostrarProyectos == true">
                <div id="divAgrupaInfo">
                    <div class="estiloBordes">
                        <span class="title">
                            <strong>PROYECTOS.</strong>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="info = true; mostrarProyectos = false"><v-icon
                                color="red">mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="bordeTabla">
                    <v-data-table :items-per-page="5" dense :headers="headersProy" :items="tablaProyectos" item-key="nombre"
                        class="elevation-1">
                    </v-data-table>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/orona.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
            mostrarPublicaciones: false,
            mostrarProyectos: false,
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'numero',
                },
                { text: 'TÍTULO', value: 'titulo' },
                { text: 'AÑO PUBLICACIÓN', value: 'publicacion' },
            ],
            Tabla: [
                {
                    numero: 1,
                    titulo: 'NORMAS NUTRIMENTALES PRELIMINARES PARA UN CULTIVAR CRIOLLO DE CAPSICUM ANNUMM CON BASE EN LA TECNICA DE DIAGNOSTICO DE NUTRIMENTO COMPUESTO, CIRILO VAZQUEZ VAZQUEZ, JUAN LUIS RIOS PLAZA, IGNACIO ORONA CASTILLO, MIGUEL ANGEL GALLEGOS ROBLES, RICARDO DAVID VALDEZ CEPEDA, JOSE LUIS GARCIA HERNANDEZ, JOSE APOLINAR RAMIREZ IBARRA, INFORMACION TECNICA ECONOMICA AGRARIA (ITEA).',
                    publicacion: 2017,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 2,
                    titulo: 'ESTABLECIMIENTO DE LA LINEA BASE PARA LA EVALUACION DEL IMPACTO TECNICO Y SOCIOECONOMICO DE LA CAMPAÑA CONTRA PLAGAS REGLAMENTADAS DEL ALGODONERO, IGNACIO ORONA CASTILLO, ROSARIO AVILA GARCIA, PEDRO CANO RIOS, JOSE DE JESUS ESPINOZA ARELLANO, ROLANDO RAMIREZ SEGOVIANO, REVISTA MEXICANA DE AGRONEGOCIOS.',
                    publicacion: 2017,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 3,
                    titulo: 'RECOLECCION Y COMERCIALIZACION DE OREGANO (LIPPIA SPP) EN EL SEMIDESIERTO MEXICANO, UN CASO DE ESTUDIO: RESERVA ECOLOGICA MUNICIPAL SIERRA Y CAÑON DE JIMULCO, JOSE DE JESUS ESPINOZA ARELLANO, ARELI JAZMIN SALVADOR ALMAZAN, IGNACIO ORONA CASTILLO, CIRILO VAZQUEZ VAZQUEZ, REVISTA MEXICANA DE AGRONEGOCIOS.',
                    publicacion: 2017,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 4,
                    titulo: 'ANALISIS COMPARATIVO DE HUERTOS DE NUEZ PECANERA (CARYA ILLINOENSIS KOCH) EN LA COMARCA LAGUNERA, CIRILO VAZQUEZ VAZQUEZ, MANUEL FORTIS HERNANDEZ, JOSE DE JESUS ESPINOZA ARELLANO, IGNACIO ORONA CASTILLO, MARIA GABRIELA CERVANTES VAZQUEZ, REVISTA MEXICANA DE CIENCIAS AGRICOLAS.',
                    publicacion: 2018,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 5,
                    titulo: 'PRODUCCION Y COMPOSICIÓN DE LECHE DE CABRAS COMPLEMENTADAS CON HOJAS SECAS DE MORINGA (MORINGA OLEÍFERA), IGNACIO ORONA CASTILLO, LORENZO DANILO GRANADOS RIVERA, EMANUEL ANTONIO ARGUELLES VERDUGO, JOSE ALONSO MALDONADO JAQUEZ, URIEL FIGUEROA VIRAMONTES, FRANCISCO JAVIER PASTOR LOPEZ, HOMERO SALINAS GONZALEZ, CIENCIA E INNOVACIÓN.',
                    publicacion: 2018,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 6,
                    titulo: 'CORN FORAGE YIELD WITH BOVINE MANURE SOLARIZED AND MYCORRHIZA, IGNACIO ORONA CASTILLO, ENRIQUE SALAZAR SOSA, JOSE LUIS GARCIA HERNANDEZ, JESUS LUNA ANGUIANO, ANA ALEJANDRA VALENZUELA GARCIA, JOSE DIMAS LOPEZ MARTINEZ, INTERNATIONAL JOURNAL OF NEW TECHNOLOGY AND RESEARCH.',
                    publicacion: 2018,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 7,
                    titulo: 'FACTORES SOCIOECONOMICOS A FORTALECER PARA MEJORAR LA PRODUCCIÓN Y COMERCIALIZACIÓN DE LA NUEZ PECANERA EN LA COMARCA LAGUNERA, LILIANA ANGELICA GUERRERO RAMOS, VICTOR MANUEL MOLINA MOREJON, JOSE DE JESUS ESPINOZA ARELLANO, MARIA GABRIELA CERVANTES VAZQUEZ, ADRIANA MONSERRAT FABELA HERNANDEZ, IGNACIO ORONA CASTILLO, REVISTA MEXICANA DE CIENCIAS AGRICOLAS.',
                    publicacion: 2019,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 8,
                    titulo: 'ANALISIS DEL FINANCIAMIENTO, COMERCIALIZACION Y RENTABILIDAD DEL CULTIVO DEL MELON CON ENFOQUE DE "SIEMBRA POR ETAPAS" EN LA COMARCA LAGUNERA DE COAHUILA, JOSE DE JESUS ESPINOZA ARELLANO, IGNACIO ORONA CASTILLO, LILIANA ANGELICA GUERRERO RAMOS, EVA CRISTINA RAMIREZ QUIROGA, VICTOR MANUEL MOLINA MOREJON, CIENCIA UAT.',
                    publicacion: 2019,
                    categoria: 'TÍTULO DEL ARTÍCULO CIENTÍFICO'
                },
                {
                    numero: 1,
                    titulo: 'FUNDAMENTOS DE AGRICULTURA ORGANICA, ENRIQUE SALAZAR SOSA, IGNACIO ORONA CASTILLO Y LUIS JAVIER HERMOSILLO SALAZAR. EDITORIAL ACADEMICA ESPAÑOLA',
                    publicacion: 2017,
                    categoria: 'TÍTULO DEL LIBRO CIENTÍFICO'
                },
                {
                    numero: 1,
                    titulo: 'RIESGOS ASOCIADOS A ENMIENDAS ORGANICAS. FRANCISCO GONZALEZ SALAS, JOSE GUADALUPE LUNA ORTEGA, ENRIQUE SALAZAR SOSA, ROBERTO SANCHEZ LUCIO, CIRILO VAZQUEZ VAZQUEZ, JOSE LUIS GARCIA HERNANDEZ, MIGUEL ANGEL GALLEGOS ROBLES, IGNACIO ORONA CASTILLOS, FUNDAMENTOS DE AGRICULTURA ORGANICA, 1, EDITORIAL ACADEMICA ESPAÑOLA',
                    publicacion: 2017,
                    categoria: 'TÍTULO DEL CAPÍTULO DE LIBRO'
                }
            ],
            headersProy: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                { text: 'PROYECTOS DE INVESTIGACIÓN', value: 'nombre' },
                { text: 'PERIODO DE EJECUCIÓN', value: 'tipo' },
            ],
            tablaProyectos: [
                {
                    id: 1,
                    nombre: 'COMERCIALIZACIÓN DE NUEZ PECANERA EN LAS PRINCIPALES REGIONES PRODUCTIVAS DE MEXICO',
                    tipo: '2016-2018'
                },
                {
                    id: 2,
                    nombre: 'PRODUCCION DE TOMATE EN MALLA SOMBRA Y SU RESPUESTA A LA APLICACIÓN DE ESTIÉRCOL SOLARIZADO Y VERMICOMPOSTA',
                    tipo: '2016-2017'
                },
                {
                    id: 3,
                    nombre: 'PRODUCTIVIDAD DEL AGUA EN LOS MODULOS DE RIEGO DEL DISTRITO 017 REGION LAGUNERA',
                    tipo: '2015-2016'
                }
            ]
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
